import { DeleteProcessesRequestPathParamType } from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const deleteProcess = async (
  payload: ApiRequest<any, DeleteProcessesRequestPathParamType>
) => {
  const resp = await api.delete<any>(
    `/v2/organizations/processes/${payload.pathParams.processId}`
  );
  return resp.data;
};

export const useDeleteProcess = () => {
  return useMutation<
    ApiRequest<any, DeleteProcessesRequestPathParamType>,
    Error,
    any,
    any
  >({
    mutationFn: async (
      payload: ApiRequest<any, DeleteProcessesRequestPathParamType>
    ) => deleteProcess(payload),
  });
};
